import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import AllBlogs from '../../components/AllBlogs';
import NewFeaturedBlogs from '../../components/NewFeaturedBlogs';
import NewSubBanner from '../../components/NewSubBanner';
import NewColumnTextWithForm from '@/components/NewColumnTextWithForm';
import {
    Container,
} from 'reactstrap';
export default function InsightsPage({
    global,
    all_news,
    all_featured_news
}) {
    return (
        <>
            <SeoHead
                page_name={`Blogs | Project engineering and technical recruitment specialists | Carbon60`}
                canonical_link={`blog`}
            />
            <NewSubBanner
                global={global}
                pathPrefix={`insights_page.new_sub_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Insights</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/banner.webp`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                editableContent={false}
            />
            <NewFeaturedBlogs
                global={global}
                pathPrefix={`insights_page.new_featured_blogs`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Featured Blogs</h2>
                    </>
                }
                post={all_featured_news}
                socialPagePrefix={`blog`}

            />
            <AllBlogs
                global={global}
                pathPrefix={`insights_page.all_blogs`}
                customClass={`py-5 lightGreybg`}
                post={all_news}
                ParentNews={true}
                heading={`All Blogs`}
            />
            <Container>
                <hr></hr>
            </Container>
            <NewColumnTextWithForm
                global={global}
                pathPrefix={`insights_page.new_column_text_with_form`}
                content={
                    <>
                        <h2>Drive better workforce performance</h2>
                        <p>Book a call with us and find out how we can help you and your team achieve greater heights.</p>
                    </>
                }
                formId={`6dfe644a-5f46-4e5d-9ba8-be0b6c0583c4`}
                customClass='py-5'
                locale=""
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const news = (await Collection('news'))

    const featured_news = news.filter((post) => 'featured' in post && post.featured?.en === true);
    const all_news = news.orderBy('date').getItems();
    const all_featured_news = featured_news.orderBy('date').getItems();

    return {
        props: {
            global,
            all_news,
            all_featured_news
        }
    };
}
